import { render, staticRenderFns } from "./filters-button.vue?vue&type=template&id=5908302c&scoped=true&"
import script from "./filters-button.vue?vue&type=script&lang=js&"
export * from "./filters-button.vue?vue&type=script&lang=js&"
import style0 from "./filters-button.vue?vue&type=style&index=0&id=5908302c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908302c",
  null
  
)

export default component.exports